import { Tooltip as HeroTooltip, TooltipPlacement } from "@heroui/react";
import { ReactNode } from "react";

type PropsType = {
  content: ReactNode;
  children: ReactNode;
  placement?: TooltipPlacement;
  offset?: number;
  delay?: number;
  closeDelay?: number;
  closeDuration?: number;
  isDisabled?: boolean;
};
const Tooltip = ({
  content,
  children,
  placement = "top",
  offset,
  delay = 300,
  closeDelay = 300,
  closeDuration,
  isDisabled = false,
}: PropsType) => {
  return (
    <HeroTooltip
      showArrow={false}
      content={content}
      isDisabled={isDisabled}
      classNames={{
        base: [
          "pointer-events-none max-w-[var(--cdl-component-tooltip-max-width)]",
        ],
        content: ["bg-bg-heavy rounded-lg text-fg-inverse p-2 tiny-normal"],
      }}
      delay={delay}
      closeDelay={closeDelay}
      placement={placement}
      offset={offset}
      motionProps={{
        variants: {
          enter: {
            opacity: 1,
            scale: 1,
          },
          exit: {
            opacity: 0,
            scale: 0.85,
            transition: { duration: closeDuration },
          },
        },
      }}
    >
      {children}
    </HeroTooltip>
  );
};

export default Tooltip;
